import React, { useState, useEffect, useContext } from "react";
import logo from "../../../assets/veoliaLogo.png";
import { useNavigate } from 'react-router-dom';
import { ConopsContext } from "../../conops-hooks/ConopsContext";
import { useAuthContext } from "../../../utils/AuthContext";
import apiClientconops from "../../../ApiEndpoint/apiClientconops";
import apiUrlconops from "../../../ApiEndpoint/configconops";

const ConopsSidebar = ({ onSessionSelect, isTyping }) => {
    const navigate = useNavigate();
    const [sessions, setSessions] = useState([]);
    const { setMessages, setMoveToBottom, setShowWelcome, setFetchSessionsFn, setRegisterid, setIsFacilitiesEmpty } = useContext(ConopsContext);
    const { user } = useAuthContext();


    const fetchSessions = async () => {
        const userEmail = user?.email;

        if (!userEmail) return;

        try {
            const res = await apiClientconops.get(`${apiUrlconops}/get_session_ids`, {
                params: { user_email: userEmail }
            });
            setSessions(res.data);
        } catch (err) {
            console.error("Failed to fetch sessions", err);
        }
    };

    useEffect(() => {
        fetchSessions();
        setFetchSessionsFn(() => fetchSessions);
    }, []);

    const handleSmartProspectingClick = () => {
        // ✅ Navigate
        //navigate("/conops-data");
        window.location.href = "/conops-data";
        // ✅ Reset states
        // setRegisterid([]);
        // setIsFacilitiesEmpty(false);
    };

    return (
        <div className="body">
            <div className="d-flex flex-column align-items-center w-100 p-4">
                <img src={logo} alt="Veolia Logo" className="img-fluid" style={{ maxWidth: "100px" }} />
                <h5 className="text-success title mt-2">SMART GROWTH ENGINE</h5>
                <button className="btn btn-primary mt-2" onClick={() => {
                    setShowWelcome(true);
                    setMessages([]);
                    setMoveToBottom(false);
                    fetchSessions();

                    sessionStorage.removeItem("currentSessionId");
                }}
                    disabled={isTyping}
                >New chat</button>

                <div className="session-list mt-4 w-100">
                    {sessions.map((session) => (
                        <button
                            key={session.session_id}
                            className="btn btn-sm btn-light text-start w-100 mb-1 sidebutton"
                            disabled={isTyping}
                            onClick={() => {
                                sessionStorage.setItem("currentSessionId", session.session_id);
                                onSessionSelect(session.session_id);
                            }}
                        >
                            {session.first_query.length > 50
                                ? `${session.first_query.slice(0, 47)}...`
                                : session.first_query}
                        </button>
                    ))}
                </div>

                <div style={{
                    position: "fixed", bottom: "20px", left: "8%", transform: "translateX(-50%)", zIndex: 1000,
                }}>
                    <button
                        onClick={handleSmartProspectingClick}
                        style={{
                            display: "inline-block",
                            padding: "12px 20px",
                            color: "white",
                            background: "#0d6efd",
                            borderRadius: "8px",
                            textDecoration: "none",
                            fontSize: "16px",
                            fontWeight: "bold",
                            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                            border: "none",
                            cursor: "pointer",
                            transition: "background 0.3s ease",
                        }}
                        onMouseOver={(e) => (e.target.style.background = "#2980b9")}
                        onMouseOut={(e) => (e.target.style.background = "#0d6efd")}
                    >
                        Smart Prospecting
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConopsSidebar;
